import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import BookingSection from '../components/AllIndustryLanding/BookingSection'
import CampaignStrategy from '../components/AllIndustryLanding/CampaignStrategy'
import FAQ from '../components/AllIndustryLanding/FAQ'
import HowItWorks from '../components/AllIndustryLanding/HowItWorks'
import AllIndustryHero from '../components/AllIndustryLanding/AllIndustryHero'
import SocialProof from '../components/AllIndustryLanding/SocialProof'
import WhyOLM from '../components/AllIndustryLanding/WhyOLM'

const ALL_INDUSTRY_FALLBACK_META = `
<meta name="description" content="Get higher response rates with targeted direct mail. Proven templates, fast turnaround, and expert coaching to help you close more deals." />
<meta property="og:title" content="Direct Mail Marketing That Works" />
<meta property="og:description" content="Get higher response rates with targeted direct mail. Proven templates, fast turnaround, and expert coaching to help you close more deals." />
`

export default function AllIndustry({ data }) {
    return (
        <LandingPageWrapper sectionSpacing={false} paddingFromTop={false}>
            <Header
                meta={data?.yoast_head || ALL_INDUSTRY_FALLBACK_META}
                metaTitle="Direct Mail Marketing That Works"
            />
            <AllIndustryHero />
            <SocialProof />
            <CampaignStrategy />
            <WhyOLM />
            <HowItWorks />
            <FAQ />
            <BookingSection />

            <style
                dangerouslySetInnerHTML={{
                    __html: `
                @media (max-width: 640px) {
                    .all-industry-form-grid {
                        grid-template-columns: 1fr !important;
                        padding: 20px !important;
                        gap: 16px !important;
                    }
                    .all-industry-form-footer {
                        justify-content: center !important;
                        text-align: center;
                    }
                    .all-industry-form-footer button {
                        width: 100%;
                    }
                }
            `,
                }}
            />
        </LandingPageWrapper>
    )
}

export async function getStaticProps() {
    let data = {}

    try {
        const page = await GeneralAPI.getPageBySlug('/all-industry')
        data = page ? page[0] || {} : {}
    } catch (e) {
        console.error(e)
    }

    try {
        const { banners } = await GeneralAPI.getACFBanners()
        data.banners = banners
    } catch (e) {
        console.error(e)
    }

    return {
        props: {
            data,
            disableHeaderLogoLink: true,
            hideCartButton: true,
            hideLoginButton: true,
            phoneNumber: '978-893-5890',
        },
        revalidate: 10,
    }
}
